import * as api from '../../services/api';
import chart from './chart';
import * as dateFormat from '../../../helpers/dateFormat';

export default {
  mixins: [chart],
  data() {
    return {
      repetitiveList: [],
      currentSort: 'MostInvalidAnsweredPointInvalidCount',
      currentSortDir: 'desc',
      pageSize: 6,
      currentPage: 1,
    };
  },
  mounted() {
    api.getRoundGapReportForDevice(
      dateFormat.postDateTimeFormatFromDateObject(moment().startOf('month').toDate()),
      dateFormat.postDateTimeFormatFromDateObject(moment().endOf('month').toDate()),
    ).then((res) => {
      this.repetitiveList = res.body.map((x) => ({
        ...x,
        MostInvalidAnsweredPointName: x.MostInvalidAnsweredPointName ? x.MostInvalidAnsweredPointName : '',
        MostInvalidAnsweredPointInvalidCount: x.MostInvalidAnsweredPointInvalidCount ? x.MostInvalidAnsweredPointInvalidCount : 0,
      }));
    });
  },
  methods: {
    redraw() {
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    nextPage() {
      if (this.currentPage * this.pageSize < this.repetitiveList.length) this.currentPage++;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  computed: {
    sortedRepetitiveList() {
      return this.repetitiveList.sort((a, b) => {
        let modifier = 1;
        if (isNaN(a[this.currentSort]) || isNaN(b[this.currentSort])) {
          const compare = a[this.currentSort].localeCompare(b[this.currentSort]);
          if (this.currentSortDir === 'asc') modifier = -1;
          if (compare > 0) return -1 * modifier;
          if (compare < 0) return 1 * modifier;
        } else {
          if (this.currentSortDir === 'asc') modifier = -1;
          if (a[this.currentSort] > b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] < b[this.currentSort]) return 1 * modifier;
        }
        return 0;
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        if (index >= start && index < end) return true;
      });
    },
    isLastPage() {
      return this.currentPage * this.pageSize >= this.repetitiveList.length;
    },
    isFirstPage() {
      return this.currentPage == 1;
    },
  },
};
